import Unauthorized from '../../../../../components/Unauthorized/Unauthorized';

export default Unauthorized;
